import { IService } from '@alberta/konexi-shared';
import { Injectable } from '@angular/core';
import { ServiceWorkItem } from 'src/app/business/service-entity/service-work-item';
import { IWorkItem } from 'src/app/common/contracts/work-item/work-item_T';

import { Command } from '../command';
import { EntityCommandHandler } from '../entity-command-handler';

@Injectable()
export class ServiceCommandHandler extends EntityCommandHandler<IService> {
  protected workItem: IWorkItem<IService>;

  constructor(serviceWorkItem: ServiceWorkItem) {
    super();
    this.workItem = serviceWorkItem;
  }

  canHandle(command: Command): boolean {
    return command.dtoName === 'ServiceDto';
  }
}
